import { useEffect } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _SignListFormat, _single } from "../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import { BasicPage } from "../../theme/Component/BasicPage";

interface Props {
    isModal?: boolean;
    _onChange?: Function;
}

export const SignListFormat = ({ isModal, _onChange }: Props) => {

    const { instance, lista, setLista, bean, setBean, validateForm, isMissing, isRequired, addRequiredFields } = useDataBean(_SignListFormat)

    const modal = useModal("", MODAL_md);
    const modalC = useModal(`Eliminar Firma ${bean.Name}`, MODAL_SM);

    const head = [
        { title: 'ID', property: "IDSignListFormat", visible: true },
        { title: 'Tipo de Firma', property: "RenderType", visible: true },
        { title: 'Titulo del cargo', property: "JobTitle", visible: true },
        { title: 'Nombre del Empleado', property: "AccountName", visible: true },
    ]

    const setRowBean = (bean: any) => {
        _onChange?.(bean);
        setBean(bean);
    }

    useEffect(() => {
        addRequiredFields(["JobTitle", "AccountName", "SignType"])
        getLista()
    }, [])

    const renderSign = (type: number) => {
        if (type == 101) {
            return "Firma Interna";
        } else if (type == 102) {
            return "Firma Externa";
        } else {
            return "N/P"
        }
    }

    const getLista = () => {
        let props: any = {
            State: 1
        }

        instance.getSignListFormatCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                resp.forEach(element => {
                    const sign = element.DataBeanProperties;

                    sign.RenderType = sign?.SignType ? renderSign(sign.SignType) : "N/P";
                });
                setLista(resp)
            }
        ).catch(err => { toast.error(err) });
    }

    const create = () => {

        let x: any = {
            State: 1,
            IDEmployee: _single.getAccountID(),
        }

        setBean(x);
        modal.open("Agregar Plantilla de Registro");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }

        instance.updateSignListFormat(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { create() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { modal.open(`Editar Firma de Registro ${bean.AccountName}`); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { modalC.open(); } }, ,
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const baseComponent = () => {
        return (
            <>
                <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean} />

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={() => { deleteItem(); }}>
                    Eliminar fima de {bean.JobTitle} - {bean.AccountName}
                </ModalConfirm>

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <label className={`${isMissing('JobTitle') ? 'has-error' : ''}`}>Titulo del Cargo {isRequired('JobTitle') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="text" className="form-control" value={bean.JobTitle} onChange={(e) => { setBean({ ...bean, JobTitle: e.target.value }) }} />
                        </div>

                        <div className="col-md-12">
                            <label className={`${isMissing('AccountName') ? 'has-error' : ''}`}>Nombre Empleado {isRequired('AccountName') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="text" className="form-control" value={bean.AccountName} onChange={(e) => { setBean({ ...bean, AccountName: e.target.value }) }} />
                        </div>

                        <div className="col-md-12">
                            <label className={`${isMissing('SignType') ? 'has-error' : ''}`}>Tipo de firma {isRequired('SignType') ? <span className="text-danger">*</span> : ''}</label>
                            <select className="form-select" value={bean.SignType} onChange={(e) => {
                                const valor = e.target.value ? Number(e.target.value) : null
                                setBean({ ...bean, SignType: valor })
                            }}>
                                <option value="">...</option>
                                <option value="101">Firma Interna</option>
                                <option value="102">Firma Externa</option>
                            </select>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Plantillas de firmas">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}
